export function publicDailyReportToken(location: Pick<Location, "hash" | "search" | "pathname">): string {
  return new URLSearchParams(location.hash.slice(1)).get("token")?.trim() ?? new URLSearchParams(location.search).get("token")?.trim() ?? location.pathname.split("/").filter(Boolean)[1] ?? "";
}
